import { atom } from "recoil";

const howManyClickAtom = atom({
  key: "howManyClickState",
  default: JSON.parse(localStorage.getItem("howManyClick")) ?? 0,
});

export default howManyClickAtom;
